var _line, _polyline, _line2, _polyline2, _line3, _polyline3, _line4, _polyline4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorAssemblyPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.425,
    y1: 3.575,
    x2: 32.162,
    y2: 9.838
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "32.45 4.996 31.862 10.138 37.003 9.549"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.575,
    y1: 38.425,
    x2: 9.838,
    y2: 32.162
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "9.55 37.004 10.138 31.862 4.997 32.451"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.575,
    y1: 3.575,
    x2: 9.838,
    y2: 9.838
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "4.996 9.55 10.138 10.138 9.549 4.997"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 38.425,
    y1: 38.425,
    x2: 32.162,
    y2: 32.162
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "37.004 32.45 31.862 31.862 32.451 37.003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.411,10.428c-5.185,0-9.387,4.203-9.387,9.388,0,5.326,9.387,12.933,9.387,12.933,0,0,9.388-7.527,9.388-12.933,0-5.185-4.203-9.388-9.388-9.388Zm-.003,11.16c-1.491,0-2.7-1.209-2.7-2.7s1.209-2.7,2.7-2.7,2.7,1.209,2.7,2.7-1.596,2.7-2.7,2.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorAssemblyPoint);
export default __webpack_public_path__ + "static/media/indoor-assembly_point.8ba6e1405b67b7f782fb944fee129ef6.svg";
export { ForwardRef as ReactComponent };